"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var checkProp = function checkProp(prop) {
  return typeof prop === 'undefined' || prop === null;
};
var _default = checkProp;
exports["default"] = _default;